import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { getApiBaseUrl,GET_ROLES } from "../../Config/Config";

const ViewUser = ({ userData }) => {
  const [roles, setRoles] = useState([]); // New state for roles

  // Fetch roles on component mount
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const res = await fetch(`${getApiBaseUrl()}${GET_ROLES}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const result = await res.json();
        if (result.Status && result.ResultData) {
          setRoles(result.ResultData);
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };
    fetchRoles();
  }, []);

  return (
    <>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasViewUser {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasViewUser {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasViewUser {
            width: 35% !important;
          }
        }
          
        @media (min-width: 1441px)  {
          #offcanvasViewUser {
            width: 20% !important;
          }
        }
        `}
      </style>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasViewUser"
        aria-labelledby="offcanvasViewUserLabel"
      >
        <div className="offcanvas-header d-flex justify-content-between align-items-center w-100">
          <h5 id="offcanvasViewUserLabel">User Details</h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <hr className="m-0" />
        <div className="offcanvas-body">
          <form>
            <div className="row">
              <div className="col-6 mb-3">
                <label className="form-label">User ID</label>
                <input
                  type="text"
                  className="form-control"
                  value={userData?.Username || ""}
                  readOnly
                />
              </div>
              <div className="col-6 mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={userData?.Name || ""}
                  readOnly
                />
              </div>
              <div className="col-6 mb-3">
                <label className="form-label">Role</label>
                <select
                  className="form-select"
                  value={userData?.Role || ""}
                  disabled
                >
                  <option value="">Select Role</option>
                  {roles.map((role) => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="d-flex justify-content-end mt-4"></div>
          </form>
        </div>
      </div>
    </>
  );
};

ViewUser.propTypes = {
  userData: PropTypes.shape({
    UserID: PropTypes.number,
    Name: PropTypes.string,
    Email: PropTypes.string,
    Phone: PropTypes.string,
    Username: PropTypes.string,
    Role: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    HasMobile: PropTypes.bool,
  }).isRequired,
};

export default ViewUser;